import { useCompanyReadDataContext } from '@aibees/elephant/context';
import { useIsFinancialInfoEmpty } from './use-is-financial-info-empty';

export function useHasFinancialInfo() {
  const { api } = useCompanyReadDataContext();
  const isEmpty = useIsFinancialInfoEmpty();

  const hasLastFundingInfo =
    api?.data?.financial?.funding?.type != null ||
    api?.data?.financial?.funding?.date != null ||
    api?.data?.financial?.funding?.last_amount != null;

  return !isEmpty || hasLastFundingInfo;
}
